import { gql, useQuery } from '@zenbusiness/application-commons-graphql';
import { useError } from '@zenbusiness/application-commons-logging';

export const ACCOUNT_SUBSCRIPTIONS_QUERY = gql`
  query AccountSubscriptions {
    accountSubscriptions {
      businessEntities {
        uuid
        name
        domesticJurisdiction
        subscriptions {
          orderBillingItemUuid
          service
          subscriptionStatus
          price
          period
          canChangePeriod
          remainingProrateValue
          inTrial
          trialDays
          trialOffer
          isActive
          isFormationComplete
          isPostPurchaseComplete
          termStartDate
          termEndDate
          cancelDate
          contractInterval
          summary
          benefits {
            label
            description
          }
          payment {
            chargeUuid
            amount
            paymentStatus
            paymentDate
            paymentTime
          }
          promotions {
            orderBillingItemUuid
            couponUuid
            netAmount
            expirationDate
            couponDetails {
              amount
            }
          }
          includes {
            orderBillingItemUuid
            service
            summary
            benefits {
              label
              description
            }
          }
        }
      }
      errorStatus
    }
  }
`;

export function useAccountSubscriptions() {
  const {
    data, loading, error, refetch
  } = useQuery(ACCOUNT_SUBSCRIPTIONS_QUERY, {
    noThrow: true,
    skipCache: true
  });

  useError(error);

  return {
    accountSubscriptions: data?.accountSubscriptions,
    loading,
    hasError: Boolean(error),
    error,
    refetch
  };
}
